module.exports = __webpack_public_path__ + "img/logo-dm.04e5646c.png";